var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCounter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 33.3333V6.66667C10 2.98958 12.9896 0 16.6667 0H43.3333C47.0104 0 50 2.98958 50 6.66667V27.2396C50 29.0104 49.3021 30.7083 48.0521 31.9583L41.9583 38.0521C40.7083 39.3021 39.0104 40 37.2396 40H16.6667C12.9896 40 10 37.0104 10 33.3333ZM28.3333 10C27.4167 10 26.6667 10.75 26.6667 11.6667V16.6667H21.6667C20.75 16.6667 20 17.4167 20 18.3333V21.6667C20 22.5833 20.75 23.3333 21.6667 23.3333H26.6667V28.3333C26.6667 29.25 27.4167 30 28.3333 30H31.6667C32.5833 30 33.3333 29.25 33.3333 28.3333V23.3333H38.3333C39.25 23.3333 40 22.5833 40 21.6667V18.3333C40 17.4167 39.25 16.6667 38.3333 16.6667H33.3333V11.6667C33.3333 10.75 32.5833 10 31.6667 10H28.3333ZM30.8333 45C32.2188 45 33.3333 46.1146 33.3333 47.5C33.3333 48.8854 32.2188 50 30.8333 50H14.1667C6.34375 50 0 43.6562 0 35.8333V12.5C0 11.1146 1.11458 10 2.5 10C3.88542 10 5 11.1146 5 12.5V35.8333C5 40.8958 9.10417 45 14.1667 45H30.8333Z",
    fill: "#303A46"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCounter);
export default __webpack_public_path__ + "static/media/counter.4c89e103d04a1f53746b07e08b021ca8.svg";
export { ForwardRef as ReactComponent };